import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import PracticeRoutinePost from "../../../components/practice-routine-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Preliminary to Grade 2",
    time: "15 to 25 minutes",
    focus: "Sitting position, bow hold, open strings, simple finger patterns, tone",
    weeklyHabit: "Use short sessions and listen carefully for ringing, relaxed sound",
  },
  {
    level: "Grades 3 to 4",
    time: "30 to 40 minutes",
    focus: "Scales, bow distribution, shifting basics, intonation, rhythm",
    weeklyHabit: "Practise slow shifts and small piece sections before full runs",
  },
  {
    level: "Grades 5 to 6",
    time: "45 to 60 minutes",
    focus: "Thumb position preparation, vibrato, articulation, phrase shape, tuning",
    weeklyHabit: "Use drones or a tuner and record passages to check tone and intonation",
  },
  {
    level: "Grades 7 to 8",
    time: "60 to 90 minutes",
    focus: "Advanced shifting, tone colour, stamina, style, performance flow",
    weeklyHabit: "Schedule technique, repertoire detail, mock performances, and recovery",
  },
]

const sections = [
  {
    title: "Preliminary to Grade 2: set up relaxed sound",
    paragraphs: [
      "Early cello practice should start with sitting position, balanced instrument setup, bow hold, open strings, and simple left-hand patterns.",
      "Short, focused sessions help students listen for a ringing sound without building tension in the shoulders, thumb, or bow arm.",
    ],
  },
  {
    title: "Grades 3 to 4: strengthen shifting and bow control",
    paragraphs: [
      "Practice can grow to 30 to 40 minutes with regular scales, bow distribution work, rhythm practice, sight reading, and small repertoire goals.",
      "Slow shifts are essential. Students should know where they are shifting from, where they are shifting to, and what the guide finger or hand shape should feel like.",
    ],
  },
  {
    title: "Grades 5 to 6: listen deeply",
    paragraphs: [
      "Middle-grade cellists need careful intonation work, tone control, vibrato development, and clearer phrase shaping. Drones, tuners, and recordings can all help.",
      "Do not let every practice become a full run-through. Isolate difficult shifts, string crossings, and bow changes until they feel predictable.",
    ],
  },
  {
    title: "Grades 7 to 8: prepare the full performance",
    paragraphs: [
      "Advanced cello practice should balance technical maintenance with musical depth. Rotate shifting, thumb position, tone colours, articulation, style, and stamina.",
      "Mock performances and accompaniment rehearsals help students test whether tone and tuning stay secure under pressure.",
    ],
  },
  {
    title: "A simple weekly rhythm",
    paragraphs: [
      "A shared calendar can make space for scales, tone, shifting, repertoire detail, sight reading, recording, rehearsal, and rest.",
      "For cello, the best weekly plan keeps sound quality at the centre instead of treating technique as separate from music.",
    ],
  },
]

const CelloPracticeRoutinesAmebLevels = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Cello Practice Schedule by AMEB Level"
        description="Plan cello practice for AMEB levels with routines for tone, bow control, shifting, intonation, repertoire, sight reading, and performance preparation."
      />
      <PracticeRoutinePost
        instrument="Cello"
        title="Cello practice routines for different AMEB levels"
        intro="A strong cello routine connects relaxed setup, warm tone, reliable shifting, and musical phrasing from the first grades through advanced study."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/ordinary-moose-13"
        image="blog-cello.png"
        imageAlt="Cello practice planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default CelloPracticeRoutinesAmebLevels
